/* eslint-disable class-methods-use-this, import/no-named-as-default-member, import/no-named-as-default */

// Import libraries
import LazyLoading from "./lib/lazy-loading";

// Import components
import Cta from "./template-parts/components/cta";
import ScrollArticle from "./template-parts/components/scroll-article";
import ScrollNextSection from "./template-parts/components/scroll-next-section";
import HandlerLinkBox from "./template-parts/components/link-box";
import Newsletter from "./template-parts/components/newsletter";
import ScrollNextDiv from "./template-parts/components/scroll-next-div";
import BtnToTop from "./template-parts/components/btn-to-top";
import SelectorContinents from "./template-parts/components/selector-continents";
import DropDownOffices from "./template-parts/components/dropdown-offices";

// Import popups
import NewsletterForm from "./template-parts/popups/newsletter-form";

// Import sections
import CardsSlider from "./template-parts/sections/cards-slider";
import TemplateCardsSlider from "./template-parts/sections/related-insights-gallery";
import ContactForm from "./template-parts/sections/contact-form";
import Hero from "./template-parts/sections/hero";
import Numbers from "./template-parts/sections/numbers";
import ResourceList from "./template-parts/sections/resource-list";
import QuoteSlider from "./template-parts/sections/quote-slider";
import GridSlider from "./template-parts/sections/grid-slider";
import SliderGallery from "./template-parts/sections/slider-gallery";
import RelatedInsights from "./template-parts/sections/related-insights";
import HeroHomeSwiper from "./template-parts/sections/hero-home-swiper";
import FeaturedContentTextImage from "./template-parts/sections/featured-content-text-image";
import FeaturedContentTextImageReverseResp from "./template-parts/sections/featured-content-text-image-reverse-resp";
import FeaturedContentTextImageNumbers from "./template-parts/sections/featured-content-text-image-numbers";
import FeaturedContentHeaderImageText from "./template-parts/sections/featured-content-header-image-text";
import FeaturedContentTextImageOverflow from "./template-parts/sections/featured-content-text-image-overflow";
import AnimationHeroSingleInsight from "./template-parts/sections/animation-hero-single-insight";
import AnimationWysiwygInsight from "./template-parts/sections/animation-wysiwyg-insights";
import Outstanding from "./template-parts/sections/outstanding";
import ConversionNew from "./template-parts/sections/conversion-new";
import Locations from "./template-parts/sections/locations";
import GridArbitraryMobileGallery from "./template-parts/sections/grid-arbitray-mobile-gallery";
import RelatedSuccessCase from "./template-parts/sections/related-success-case";
import GalleryArbitrary from "./template-parts/sections/gallery-arbitrary";
import AnimationHeroDigitalIt from "./template-parts/sections/animation-hero-digital-it";
import AnimationImageOverflowBottom from "./template-parts/sections/animation-image-overflow-bottom";
import AnimationGridArbitraryContent from "./template-parts/sections/animation-grid-arbitrary-content";
import AnimationGalleryArbitrary from "./template-parts/sections/animation-gallery-arbitrary";
import AnimationTwoColsImageText from "./template-parts/sections/animation-two-cols-image-text";
import AnimationRelatedSuccessCase from "./template-parts/sections/animation-related-success-cases";
import AnimationRelatedNews from "./template-parts/sections/animation-related-news";
import AnimationGridArbitraryContentMobileGallery from "./template-parts/sections/animation-grid-arbitrarycontent-mobile-gallery";
import AnimationFourColsWithIcons from "./template-parts/sections/animation-four-cols-with-icons";
import AnimationLinkBox from "./template-parts/sections/animation-link-box";
import AnimationPaginationSuccessCases from "./template-parts/sections/animation-pagination-related-success-cases";
import AnimationPaginationSuccessCasesGrid from "./template-parts/sections/animation-pagination-related-success-cases-grid";
import ExQuotesGallery from "./template-parts/sections/ex-quotes-gallery";
import ExTabBoxHandler from "./template-parts/sections/ex-tab-box-handler";
import PaginaDondeEstamos from "./template-parts/sections/pagina-donde-estamos";
import AnimationDondeEstamos from "./template-parts/sections/animation-donde-estamos";

// Import templates.
import SingleEvent from "./templates/single-event";
import AnimationSingleLocation from "./templates/animation-single-location";

// Subs
import Subs2ColsDesplegables from "./template-parts/sections/subs-2-cols-desplegable";
import SubsTextGallery from "./template-parts/sections/subs-text-gallery";

//Animation GSAP Subs
import AnimationSubs2ColsDesplegable from "./template-parts/sections/animation-subs-2-cols-desplegable";
import AnimationSubs2Cols from "./template-parts/sections/animation-subs-2-cols";
import AnimationSubsArbitraryCols from "./template-parts/sections/animation-subs-arbitrary-cols";
import AnimationSubsHero from "./template-parts/sections/animation-subs-hero";
import AnimationSubsSingleTextImage from "./template-parts/sections/animation-subs-single-text-image";
import AnimationSubsSubHero from "./template-parts/sections/animation-subs-sub-hero";
import AnimationSubsTextAndColumns from "./template-parts/sections/animation-subs-text-and-columns";
import AnimationSubsTextGallery from "./template-parts/sections/animation-subs-text-gallery";

//Animation GSAP Ex
import AnimationExHero from "./template-parts/sections/animation-ex-hero";
import AnimationExTabBox from "./template-parts/sections/animation-ex-tab-box";
import AnimationExQuotes from "./template-parts/sections/animation-ex-quotes";
import AnimationExVideoPopup from "./template-parts/sections/animation-ex-video-popup";

//Filters
import HandlerFilters from "./template-parts/components/handler-filters";
import CloseFilters from "./template-parts/components/close-filters";
import BtnFilterFixed from "./template-parts/components/btn-filter-fixed";

//Land
import LandHeroHomeSwiper from "./template-parts/sections/land-hero-home-swiper";
import AnimationLandVideoPopup from "./template-parts/sections/animation-land-video-popup";
import BgMobileLandHero from "./template-parts/components/bg_mobile_land_hero";

// Search
import Search from "./lib/search";

export default class ModulesLoader {
	constructor(el = document) {
		this.el = el;
	}

	loadModules() {
		// Load libraries
		window.lazyLoading = new LazyLoading();

		// Load components
		window.cta = new Cta();
		window.Newsletter = new Newsletter();
		window.scrollNextSection = new ScrollNextSection();
		window.scrollNextDiv = new ScrollNextDiv();
		window.handlerLinkBox = new HandlerLinkBox();
		window.scrollArticle = new ScrollArticle();
		window.handlerFilters = new HandlerFilters();
		window.closeFilters = new CloseFilters();
		window.btnFilterFixed = new BtnFilterFixed();
		window.btnToTop = new BtnToTop()
		window.selectorContinents = new SelectorContinents()
		window.dropDownOffices = new DropDownOffices()

		// Load popups
		window.newsletterForm = new NewsletterForm();

		// Load sections
		window.locations = new Locations();
		window.cardsSlider = new CardsSlider();
		window.templateCardsSlider = new TemplateCardsSlider();
		window.quoteSlider = QuoteSlider();
		window.gridSlider = GridSlider();
		window.contactForm = new ContactForm();
		window.numbers = new Numbers();
		window.resourceList = new ResourceList();
		window.sliderGallery = new SliderGallery();
		window.relatedInsights = new RelatedInsights();
		window.heroHomeSwiper = new HeroHomeSwiper();
		window.featuredContentTextImage = new FeaturedContentTextImage();
		window.featuredContentTextImageNumbers = new FeaturedContentTextImageNumbers();
		window.featuredContentTextImageReverseResp = new FeaturedContentTextImageReverseResp();
		window.featuredContentHeaderImageText = new FeaturedContentHeaderImageText();
		window.featuredContentTextImageOverflow = new FeaturedContentTextImageOverflow();
		window.AnimationHeroSingleInsight = new AnimationHeroSingleInsight();
		window.AnimationWysiwygInsight = new AnimationWysiwygInsight();
		window.outstanding = new Outstanding();
		window.conversionNew = new ConversionNew();
		window.hero = Hero();
		window.singleEvent = SingleEvent();
		window.gridArbitraryMobileGallery = new GridArbitraryMobileGallery();
		window.relatedSuccessCase = new RelatedSuccessCase();
		window.galleryArbitrary = new GalleryArbitrary();
		window.animationHeroDigitalIt = new AnimationHeroDigitalIt();
		window.animationImageOverflowBottom = new AnimationImageOverflowBottom();
		window.animationGridArbitraryContent = new AnimationGridArbitraryContent();
		window.animationGalleryArbitrary = new AnimationGalleryArbitrary();
		window.animationTwoColsImageText = new AnimationTwoColsImageText();
		window.animationRelatedSuccessCase = new AnimationRelatedSuccessCase();
		window.animationRelatedNews = new AnimationRelatedNews();
		window.animationGridArbitraryContentMobileGallery = new AnimationGridArbitraryContentMobileGallery();
		window.animationFourColsWithIcons = new AnimationFourColsWithIcons();
		window.animationLinkBox = new AnimationLinkBox();
		window.animationLinkBox = new AnimationLinkBox();
		window.animationPaginationSuccessCases = new AnimationPaginationSuccessCases();
		window.animationPaginationSuccessCasesGrid = new AnimationPaginationSuccessCasesGrid();
		window.exQuotesGallery = new ExQuotesGallery();
		window.exTabBoxHandler = new ExTabBoxHandler();
		window.paginasDondeEstamos = new PaginaDondeEstamos();
		window.animationDondeEstamos = new AnimationDondeEstamos();
		
		// Subs
		window.aubs2ColsDesplegables = new Subs2ColsDesplegables();
		window.subsTextGallery = new SubsTextGallery();
		
		//Animation GSAP Subs
		window.animationSubs2ColsDesplegable = new AnimationSubs2ColsDesplegable();
		window.animationSubs2Cols = new AnimationSubs2Cols();
		window.animationSubsArbitraryCols = new AnimationSubsArbitraryCols();
		window.animationSubsHero = new AnimationSubsHero();
		window.animationSubsSingleTextImage = new AnimationSubsSingleTextImage();
		window.animationSubsSubHero = new AnimationSubsSubHero();
		window.animationSubsTextAndColumns = new AnimationSubsTextAndColumns();
		window.animationSubsTextGallery = new AnimationSubsTextGallery();

		//Animation GSAP EX
		window.animationExHero = new AnimationExHero();
		window.animationExTabBox = new AnimationExTabBox();
		window.animationExQuotes = new AnimationExQuotes();
		window.animationExVideoPopup = new AnimationExVideoPopup();
		
		//Land
		window.landHeroHomeSwiper = new LandHeroHomeSwiper();
		window.animationLandVideoPopup = new AnimationLandVideoPopup();
		window.bgMobileLandHero = new BgMobileLandHero();

		// Search
		window.search = new Search();

		//Animation GSAP LOCATIONS
		window.AnimationSingleLocation = new AnimationSingleLocation();
	}
}
